import sanitize from 'sanitize-html';

/**
 * Use before storing anything in the database that could be exposed via ReactHtmlParser
 */
export const sanitizeHtml = (htmlString: string) =>
  sanitize(htmlString, {
    allowedTags: ['br', 'b', 'i', 'em', 'strong', 'a', 'ul', 'ol', 'li'],
    allowedAttributes: {
      a: ['href', 'target'],
    },
  });
